import React, { useState } from "react";
import { FaCopy, FaCheck } from "react-icons/fa";
import { toast } from "react-toastify";
import { BASE_URL_COMPETITION, CORPORATE_NAME } from "../../api/Constants";
const CopyLinkModal = ({ shareId, setShareId, setshowModal, page, link }) => {
  const base_url = `${BASE_URL_COMPETITION}/${
    page === "event"
      ? "event-detail"
      : page === "community"
      ? "community-detail"
      : page === "program"
      ? "workout-program"
      : page === "group"
      ? "Group"
      : page === "activity"
      ? "Activity"
      : page === "challenge"
      ? "Challange"
      : "competition-detail"
  }/`;
  const [isCoppied, setIsCoppied] = useState(false);

  // chaning status of cpied text icon
  const copyStatus = () => {
    setTimeout(() => {
      setIsCoppied(false);
    }, 3000);
  };

  // copy link to clipboard
  const handleCopyLink = (linkText) => {
    setIsCoppied(true);
    navigator.clipboard.writeText(linkText);

    toast.success("Link copied to clipboard!", {
      autoClose: 2000,
      pauseOnHover: true,
      draggable: true,
    });
  };

  return (
    <div className="alert-modal">
      <div className="alert-modal-box">
        <div className="alert-modal-container">
          <div className="d-flex justify-content-end ">
            <i
              className="fa fa-times"
              onClick={() => {
                setshowModal(false);
                setShareId(null);
              }}
            ></i>
          </div>
          <header className="alert-modal-heading">{CORPORATE_NAME}</header>
          <body className="d-flex flex-column justify-content-between align-item-center alert-modal-body gap-1 px-3">
            <p className="copy-label mb-1">
              {`COPY THE ${
                page === "event"
                  ? "EVENT"
                  : page === "community"
                  ? "COMMUNITY"
                  : page === "program"
                  ? "workout-program"
                  : page === "group"
                  ? "GROUP"
                  : page === "activity"
                  ? "ACTIVITY"
                  : page === "challenge"
                  ? "CHALLENGE"
                  : page === "compete"
                  ? "CATEGORY"
                  : "COMPETITION"
              } LINK TO YOUR CLIPBOARD`}
            </p>
            <div
              className="d-flex flex-row justify-content-between  linkbox"
              id="r5"
              style={{ filter: " blur(0px)", opacity: "1" }}
            >
              <span
                id={shareId}
                onClick={() => {
                  handleCopyLink(
                    (page === "event" ||
                      page === "program" ||
                      page === "group" ||
                      page === "challenge" ||
                      page === "activity") &&
                      link
                      ? link?.message + "    " + link?.data
                      : base_url + shareId
                  );
                  copyStatus();
                }}
              >
                {(page === "event" ||
                  page === "program" ||
                  page === "compete" ||
                  page === "group" ||
                  page === "challenge" ||
                  page === "activity") &&
                link
                  ? link?.data
                  : base_url + shareId}
              </span>
              {!isCoppied ? (
                <FaCopy
                  className="copy-icon"
                  onClick={() => {
                    handleCopyLink(
                      page === "event" ||
                        page === "compete" ||
                        page === "program"
                        ? link?.message + "    " + link?.data
                        : base_url + shareId
                    );
                    copyStatus();
                  }}
                />
              ) : (
                <FaCheck className="copy-icon" />
              )}
            </div>
            {page === "program" && (
              <div className="copy-redirect d-flex flex-column justify-content-center align-items-center">
                <span
                  className="redirect-button pointer"
                  onClick={() => {
                    if (link?.data) {
                      window.open(link.data, "_blank");
                      setshowModal(false);
                      setShareId(null);
                    }
                  }}
                >
                  View Detail
                </span>
                <span className="label">
                  It will redirect you to the Voro app
                </span>
              </div>
            )}
            <div className="d-flex flex-row justify-content-end gap-1 px-2 mb-3 alert-modal-button">
              <p
                className="alert-modal-yes"
                onClick={() => {
                  setshowModal(false);
                  setShareId(null);
                }}
              >
                Close
              </p>
            </div>
          </body>
        </div>
      </div>
    </div>
  );
};

export default CopyLinkModal;
